import { enableProdMode, provideCheckNoChangesConfig, provideZonelessChangeDetection } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import { EnvironmentType } from './app/app.environment'

if (environment.environment === EnvironmentType.PRODUCTION || environment.environment === EnvironmentType.BETA) {
  enableProdMode()
}

platformBrowserDynamic().bootstrapModule(AppModule, {
  // Tarkistus toimii vain kehitystilassa (ng serve) ja paljastaa sidonnat, jotka muuttuvat ilmoittamatta muutoksesta.
  // Ajastettuna se löytää myös muutokset, joiden jälkeen mikään muu ei käynnistä muutostunnistusta.
  applicationProviders: [provideZonelessChangeDetection(), provideCheckNoChangesConfig({ exhaustive: true, interval: 1000 })],
})
